import Morpheme from './morpheme.js'

export default class Form extends Morpheme {
}
